import React from "react";
import { STLinearProgress } from "./styles";
import { inject, observer } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { observable } from "mobx";
import { RouterStore } from "mobx-react-router";

interface IProps {
  values?: IValuesStore;
  routing?: RouterStore;
}

@inject("values", "routing")
@observer
class LinearProgress extends React.Component<IProps> {
  @observable node: HTMLElement;

  constructor(props: IProps) {
    super(props);
    this.node = document.querySelector("body");
  }

  componentWillUnmount() {
    this.node = null;
  }

  applyBlocker = () => {
    this.node.style.pointerEvents = "none";
    this.node.style.opacity = "0.75";
  };

  removeBlocker = () => {
    this.node.style.pointerEvents = "auto";
    this.node.style.opacity = "1";
  };

  render() {
    if (this.props.values.showRequestProgress) {
      this.applyBlocker();
      return (
        <STLinearProgress
          pinToTop={this.props.routing.location.pathname.match("/login")}
        />
      );
    }
    this.removeBlocker();
    return null;
  }
}

export default LinearProgress;
